<!--扫码揽件 -->
<template>
  <div class="index-index-container">
    <div class="index-index-list">
      <div class="index-list-info">
        <div class="order-info">
          <div class="left">
            <van-image width="20" height="20" fit="cover" :src="imgeIncon" />
            <span>蜜蜂：{{item.beesAccount}}</span>
          </div>
          <div class="right">{{item.branchName}}</div>
        </div>
        <div class="order-number">
          <span>订单号：{{item.subOrderCode}}</span>
          <span v-if="active==0 || active==1">{{item.pushTime}}</span>
          <span v-else-if="active==3">{{item.printTIme}}</span>
          <span v-else-if="active==2">{{item.cancelTime}}</span>
        </div>
      </div>
      <div class="index-list-address">
        <div class="address-info">
          <van-image style="vertical-align:middle;" width="20" height="20" fit="cover" :src="jiIncon" />
          <div class="name">
            <div class="printName" v-if="active==3">{{item.printStatusDesc}}</div>
            <p>{{item.shipperName}}&nbsp;&nbsp;{{item.shipperMobile}}</p>
            <span>{{item.shipperProvince}} {{item.shipperCity}} {{item.shipperDistrict}} {{item.shipperDetailAddress}}</span>
          </div>
        </div>
        <div class="address-info">
          <van-image style="vertical-align:middle;" width="20" height="20" fit="cover" :src="shouIncon" />
          <div class="name">
            <p>{{item.receiverName}}&nbsp;&nbsp;{{item.receiverMobile}}</p>
            <span>{{item.receiverDetailAddress}}</span>
          </div>
        </div>
      </div>
      <div class="index-list-button">
        <van-button class="button n1" size="small" @click="onReviceOrder" v-if="active==0">接单</van-button>
        <van-button class="button" size="small" @click="onCancelOrder" v-if="active==1">取消接单</van-button>
        <van-button class="button n1" size="small" @click="onPrintOrder" v-if="active==1">打印面单</van-button>
        <van-button class="button n1" size="small" @click="onAgainPrintOrder" v-if="active==3">重打已生成面单</van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    item: { default: function () { return {}; }, type: Object, required: true, },
    active: { default: function () { return ''; }, type: [String, Number] }
  },
  data() {
    return {
      imgeIncon: require('@/assets/image/mayi.png'),
      jiIncon: require('@/assets/image/jicun.png'),
      shouIncon: require('@/assets/image/shou.png'),
      wlVisible: false,
      wlsubid: ''
    }
  },
  methods: {
    onReviceOrder() {
      this.$emit('reviceOrder', this.item)
    },
    onCancelOrder() {
      this.$dialog.alert({
        title: '确认取消接单吗？',
        message: '取消后该单将不能继续打印，需要蜜蜂重新推送',
        confirmButtonText: '确认取消',
        cancelButtonText: '我不取消了',
        showCancelButton: true,
        confirmButtonColor: '#ED3939',
        cancelButtonColor: '#333333'
      }).then(() => {
        this.$emit('cancelOrder', this.item)
      }).catch(() => {});
    },
    onPrintOrder() {
      this.$emit('printOrder', this.item)
    },
    onAgainPrintOrder() {
      this.$dialog.alert({
        title: '确认重打已生成面单吗？',
        message: '1 如快递面单已损毁或丢失，可确认重新打<br>2 打印次数可以在面单上查看',
        confirmButtonText: '确认重打',
        cancelButtonText: '我不打了',
        showCancelButton: true,
        confirmButtonColor: '#ED3939',
        cancelButtonColor: '#333333'
      }).then(() => {
        this.$emit('againPrintOrder', this.item)
      }).catch(() => {});
    }
  },
  mounted(){},
  components: {},
};
</script>
<style lang="less" scoped> 
.index-index-container{
  display: flex;
  flex-direction: column;
  .index-index-list{
    display: flex;
    flex-direction: column;
    background-color: white;
    margin-bottom: 10px;
    .index-list-info{
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 0 40px;
      height: 136px;
      border-bottom: 1px solid #eeeeee;
      .order-info{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 15px;
        .left{
          display: flex;
          align-items: center;
          span{
            font-size: 24px;
            padding-left: 20px;
          }
        }
        .right{
          font-size: 24px;
          color: #333333;
        }
      }
      .order-number{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
          font-size: 24px;
          color: #999999;
        }
      }
    }
    .index-list-address{
      display: flex;
      flex-direction: column;
      .address-info{
        position: relative;
        display: flex;
        align-items: flex-start;
        padding: 20px 40px;
        border-bottom: 1px solid #eeeeee;
        .name{
          display: flex;
          flex-direction: column;
          padding-left: 20px;
          .printName{
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 24px;
            color: #F8A651;
          }
          p{
            font-size: 24px;
            font-weight: bolder;
            color: #333333;
          }
          span{
            font-size: 24px;
            color: #999999;
          }
        }
      }
    }
    .index-list-button{
      display: block;
      text-align: right;
      padding: 0 40px;
      height: auto;
      line-height: normal;
      .button{
        display: inline-block;
        vertical-align: middle;
        border-radius: 10px;
        height: 60px;
        margin-left: 20px;
        margin-top: -12px;
        min-width: 135px;
      }
      .n1{
        background-color: var(--epButtonColor);
        color: var(--epTextColor);
      }
    }
  }
}
</style>